import { render, staticRenderFns } from "./UserDetailsInstructorForm.vue?vue&type=template&id=4aa5b00b&"
import script from "./UserDetailsInstructorForm.vue?vue&type=script&lang=js&"
export * from "./UserDetailsInstructorForm.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsInstructorForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports